<template>
    <div class="content animated fadeIn">
        <div class="top">
            <div class="top-title">搜索</div>
            <div class="searchBox">
                <img src="../assets/images/search2.png" alt="">
                <input type="text" placeholder="请输入查询内容" v-model="searchVal">
                <button @click="search">搜 索</button>
            </div>
            <img src="../assets/images/fh.png" alt="" @click="backPrev">
        </div>
        <div class="main">
            <div class="record" v-if="searchValList.length > 0 && !nullData">
                <div class="titleBox">
                    <h3>使用记录</h3>
                    <a href="javascript:void(0)" @click="clearLocalStorage">清除记录</a>
                </div>
                <div class="recordList" >
                    <span v-for="item in searchValList" :key="item" @click="quickSearch(item)">{{item}}</span>
                </div>
            </div>
            <ul class="appBox">
                <li v-for="item in appList" :key="item.appId">
                    <img v-if="item.appIntranet==1" src="../assets/images/nei_icon.png" class="school" alt="">
                    <img :src="item.appImages" alt="">
                    <!-- <img src="../assets/images/getImg.gif" alt=""> -->
                    <p>{{item.appName}}</p>
                    <p style="color: #8f8f94">来源:{{item.systemName}}</p>
                    <button @click="operationWyy(item.appId,item.appUrl)">
                        进入
                    </button>
                </li>
            </ul>
            <div v-if="nullData" class="empty-wrap">
                <div class="empty-title">搜索结果</div>
                <div class="empty-img">
                    <img src="../assets/images/empty.png" alt="">
                    <div class="text">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {Toast} from 'vant';
    export default {
        computed: {
            ...mapState(['memberInfo']),
        },
        data() {
            return {
                searchVal: '',
                searchValList: [],
                appList: [],
                nullData: false
            }
        },
        mounted() {
            if (localStorage.getItem('searchVal') != null && localStorage.getItem('searchVal').length > 0) {
                this.searchValList = localStorage.getItem('searchVal').split(',');
            }
        },
        methods: {
            backPrev() {
                this.$router.go(-1);
            },
            clearLocalStorage() {
                localStorage.removeItem('searchVal')
                this.searchValList = [];
            },
            operationWyy(id,url){
                this.$common.appAccessStatistical(id)
                if(url == 'http://' || url == 'https://'){
                    Toast('系统建设中，敬请期待！')
                }else{
                    location.href = url;
                }
            },
            search() {
                // if(this.searchVal.trim()==''){
                //     Toast('请输入搜素关键字')
                //     return
                // }
                if (this.searchValList.indexOf(this.searchVal) == -1) {
                    if (this.searchVal.trim() !== '') {
                        this.searchValList.push(this.searchVal)
                        localStorage.setItem('searchVal', this.searchValList.join(','))
                    }
                }
                this.searchApp();
            },
            quickSearch(val) {
                this.searchVal = val;
                this.searchApp();
            },
            searchApp() {
                this.$axios({
                    url: baseUrl + '/app/findAppList',
                    method: 'POST',
                    data: this.qs.stringify({
                        appName: this.searchVal,
                        appUpordown: 0
                    })
                }).then(res => {
                    if (res.success) {
                        this.nullData = false;
                        this.setSearchtData(res)
                    } else {
                        this.appList = [];
                        this.nullData = true;
                        Toast('没有应用数据')
                    }
                }, error => {

                })
            },
            setSearchtData(res) {
                for (let i = 0; i < res.obj.list.length; i++) {
                    if (res.obj.list[i].appUrl != null && res.obj.list[i].appUrl != "" && this.memberInfo != '') {
                        res.obj.list[i].appUrl = res.obj.list[i].appUrl.replace("{memberid}", this.memberInfo.memberUsername)
                        if (res.obj.list[i].appUrl.indexOf("{memberAesEncrypt}") > -1) {
                            res.obj.list[i].appUrl = res.obj.list[i].appUrl.replace("{memberAesEncrypt}", this.$common.getSecretKey(res.obj.list[i].appId))
                        }
                        res.obj.list[i].appUrl = res.obj.list[i].appUrl.replace("{quicklyTicket}", this.memberInfo.quicklyTicket)
                    }
                    res.obj.list[i].appImages = baseUrl + '/public/getImg?path=' + encodeURI(res.obj.list[i].appImages)
                }
                this.appList = res.obj.list;
            }
        }
    }
</script>

<style scoped lang="less">
    .content {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        background: linear-gradient(-90deg, #28ABFC, #286DFC);
    }

    .top {
        width: 100%;
        box-sizing: border-box;
        height: 2.4rem;
        padding: .28rem;
        position:relative;
    }
    .top .top-title{
        font-size: .36rem;
        color: #fff;
        font-weight: 600;
        text-align: center;
    }
    .top img {
        position:absolute;
        top:.28rem;
        left:.28rem;
        height: .36rem;
        display: inline-block;
        margin-right: .36rem;
    }
    .main::-webkit-scrollbar{
        display: none!important;
        width: 0px;  
        height: 0px;
    } 
    .main {
        width: 100%;
        height: calc(100% - 2.4rem);
        overflow-y: auto;
        background-color: #fff;
        border-radius: 20px;
        padding: .28rem;
        box-sizing: border-box;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .searchBox {
        margin-top: .48rem;
        height: .33rem;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .searchBox img {
        width: .336rem;
        height: auto;
        position: absolute;
        left: 0.16rem;
        top: 50%;
        transform: translateY(-50%);
    }

    .searchBox input {
        display: inline-block;
        width: 70%;
        height: .576rem;
        border-radius: .72rem;
        border: none;
        outline: none;
        padding: 0 .24rem 0 .72rem;
        box-sizing: border-box;
        font-size:.24rem;
    }

    .searchBox button {
        display: inline-block;
        width: 27%;
        height: .576rem;
        color: #287AFC;
        background-color: #fff;
        border-radius: .28rem;
        border: none;
        outline: none;
        font-size: .24rem;
        font-weight: 600;
    }

    .titleBox {
        margin: .36rem 0;
        height: .48rem;
        position: relative;
    }

    .titleBox h3 {
        display: inline-block;
        margin: 0;
        font-size: .36rem;
        font-weight: 600;
        color: #282828;
        float: left;
    }

    .titleBox a {
        display: inline-block;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: .22rem;
        color: #287AFC;
    }
    .recordList{
        display:flex;
        flex-wrap: wrap;
    }
    .recordList span {
        display: inline-block;
        padding: 5px .36rem;
        background: #B1D6FA;
        border-radius: .48rem;
        font-size: .24rem;
        color: #787878;
        margin: 0 .48rem .24rem 0;
    }

    .appBox {
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .appBox li {
        /* border-bottom: 1px solid #dddddd; */
        padding: .24rem 1.2rem .24rem .96rem;
        position: relative;
        height: .72rem;
    }

    .appBox li:first-of-type {
        /* border-top: 1px solid #dddddd; */
    }

    .appBox li img {
        width: .72rem;
        height: .72rem;
        position: absolute;
        left: 0;
        display: inline-block;
    }
    .appBox li .school{
        display: inline-block;
        width: 15px;
        height: 15px;
        position: absolute;
        left: .6rem;
        top: 5px;
        z-index: 100;
    }
    .appBox li p {
        margin: 0;
        font-size: .28rem;
    }
    
    .appBox li button {
        width:.84rem;
        height: .45rem;
        background-color: #fff;
        border: 1px solid #286DFC;
        color: #286DFC;
        outline: none;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        padding: 2px 8px;
        border-radius: 1.2rem;
        text-align: center;
        font-size:.24rem;
    }
    @media screen and (max-width: 374px) {
        .appBox li button{
            width:1rem;
            padding:0 8px;
        }
    }
    .empty-wrap{
        .empty-title{
            font-size:.28rem;
            font-weight: 600;
            // color:#333;
        }
        .empty-img{
            text-align: center;
            margin-top:2rem;
            img{
                width:3rem;
                height: 3rem;
            }
            .text{
                font-size:.32rem;
                color:#aaa;
            }

        }
    }

</style>
